import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"
}), 'SubjectOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SubjectOutlined.js
// module id = 6564
// module chunks = 2